// Cap and quiet-hour arithmetic for the Controls page. Pure.

/** Renders the quiet window as a sentence, with the community's own clock. */
export function quietHoursSentence(
  start: number, end: number, timeZone: string, now: Date = new Date(),
): string {
  const h = (n: number) => {
    const am = n < 12
    const hh = n % 12 === 0 ? 12 : n % 12
    return `${hh}:00 ${am ? 'AM' : 'PM'}`
  }
  if (start === end) return 'Quiet hours are off — the agent may send at any time of day.'
  let local: string
  try {
    local = new Intl.DateTimeFormat('en-US', {
      timeZone, hour: 'numeric', minute: '2-digit', hour12: true,
    }).format(now)
  } catch {
    local = 'unknown'
  }
  const quiet = isQuietNow(start, end, timeZone, now)
  return `The agent will not send between ${h(start)} and ${h(end)} ${timeZone}. ` +
    `Right now it is ${local} there — sending is ${quiet ? 'held' : 'allowed'}.`
}

export function isQuietNow(
  start: number, end: number, timeZone: string, now: Date = new Date(),
): boolean {
  if (start === end) return false
  let h: number
  try {
    h = Number(new Intl.DateTimeFormat('en-US', { timeZone, hour: 'numeric', hour12: false }).format(now)) % 24
  } catch {
    return false
  }
  return start < end ? h >= start && h < end : h >= start || h < end
}

/** True when every cap is above zero, i.e. the agent could actually send. */
export function capsAllPositive(s: {
  max_per_member_per_day: number
  max_per_member_per_week: number
  max_broadcasts_per_week: number
  max_sends_per_run: number
}): boolean {
  return s.max_per_member_per_day > 0 && s.max_per_member_per_week > 0 &&
    s.max_broadcasts_per_week > 0 && s.max_sends_per_run > 0
}
